'use client';
import Image from 'next/image';
import cn from 'classnames';

import ArrowDown from 'public/img/icon/arrow-down.svg';

import './ButtonScrollToBottom.style.scss';

type ButtonScrollToBottomProps = {
  isAtBottom: boolean;
  onClick: () => void;
  className?: string;
};

function ButtonScrollToBottom(props: ButtonScrollToBottomProps) {
  const { className = '', isAtBottom, onClick } = props;

  return (
    <button
      className={cn(
        'ButtonScrollToBottom',
        isAtBottom ? 'hide' : '',
        className
      )}
      onClick={onClick}
    >
      <Image
        src={ArrowDown}
        height={16}
        width={16}
        alt=''
        priority
      />
    </button>
  );
}

export default ButtonScrollToBottom;
